module.exports = __webpack_public_path__ + "img/cns_email_mac9.92e5aec3.png";